import dynamic from 'next/dynamic';
import css from './index.module.scss';
import FirstKv from './components/FirstKv';
import { useGlobal } from '@/utils/useGlobal';
import Annotation from '@/components/Annotation';

const PageConPc = dynamic(() => import('@/components/productSmart/glacier/treaser/indexDynamic'), {
    ssr: true,
});

export default function GlacierTeaserPC() {
    const { useRouter, useEffect } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    useEffect(() => {
        // 由于pages下404允许了， cn，jp, za有详情页、无预热
        if (['jp', 'cn'].includes(locale)) {
            router.push('/404');
        }
    }, []);
    return (
        <div className={`glacier-teaser-pc ${css.glacierTeaserPC}`}>
            <FirstKv />
            <PageConPc />
            <Annotation borderTopColor="transparent" bgColor="transparent" boxStyle={{ width: '1120px' }} product="GLACIER" />
            <style jsx global>
                {`
                    .product_naver .detail-nav {
                        display: none !important;
                    }
                    .ant-modal-root .ef-popup {
                        .ant-modal-close {
                            left: unset;
                            right: 30px;
                            top: 30px;
                        }
                        .ant-modal-body {
                            .popup-title {
                                font-family: var(--font-family-Medium);
                            }
                            .popup-text {
                                font-family: var(--font-family-Medium);
                                color: #919191;
                            }
                        }
                    }
                `}
            </style>
        </div>
    );
}
